import { ProcessManagerFunction } from "@lookiero/messaging";
import { resetCheckout } from "../../checkout/command/resetCheckout";
import { CheckoutBookingExpired } from "../model/checkoutBookingExpired";

interface ResetCheckoutWhenCheckoutBookingExpiredFunction extends ProcessManagerFunction<CheckoutBookingExpired> {}

const resetCheckoutWhenCheckoutBookingExpired: ResetCheckoutWhenCheckoutBookingExpiredFunction =
  ({ commandBus }) =>
  async ({ checkoutId }) => {
    await commandBus(resetCheckout({ aggregateId: checkoutId }));
  };

export { resetCheckoutWhenCheckoutBookingExpired };
